import { useEffect, useRef } from "react";

import AdminGlobalRolesSelector, { GlobalRolesSelectorProps } from "./AdminGlobalRolesSelector";
import AdminTenantRolesSelector, { TenantRolesSelectorProps } from "./AdminTenantRolesSelector";

type ScopeType = "global" | "tenant";

type Props = (GlobalRolesSelectorProps & TenantRolesSelectorProps) & {
  scopeType: ScopeType;
  onScopeTypeChange?: (params?: {
    oldValue?: ScopeType | null;
    newValue?: ScopeType | null;
  }) => void;
};

export default function AdminGlobalOrTenantRolesSelector({
  scopeType,
  onScopeTypeChange,
  ...otherProps
}: Props) {
  const prevScopeType = useRef<ScopeType | undefined>(scopeType);

  useEffect(() => {
    if (scopeType !== prevScopeType.current) {
      onScopeTypeChange &&
        onScopeTypeChange({ oldValue: prevScopeType.current, newValue: scopeType });
      prevScopeType.current = scopeType;
    }
  }, [scopeType]);

  if (scopeType === "global") {
    return <AdminGlobalRolesSelector {...otherProps} />;
  }
  if (scopeType === "tenant") {
    return <AdminTenantRolesSelector {...otherProps} />;
  }
  return null;
}
